import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX, FiPlay } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  const filmLinks = [
    { name: 'Tinman', path: '/tinman' },
    { name: 'The Playground', path: '/playground' },
    { name: 'Truth & Fairytales', path: '/fairytales' },
    { name: 'The Festivals', path: '/festivals' }
  ];

  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-in-out ${
        scrolled || location.pathname !== '/' ? 'bg-black/95 backdrop-blur-lg shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex-shrink-0 group">
            <div className={`text-2xl font-serif font-bold tracking-tight uppercase transition-colors duration-500 ${
              scrolled || location.pathname !== '/' ? 'text-white' : 'text-black'
            }`}>
              SANDSTORM<span className="text-accent-orange">FLIX</span>
            </div>
          </Link>
          
          <nav className="hidden lg:block">
            <div className="flex items-center space-x-8">
              {filmLinks.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`text-[10px] font-bold transition-all duration-500 tracking-[0.2em] uppercase ${
                    location.pathname === item.path 
                      ? 'text-accent-orange' 
                      : (scrolled || location.pathname !== '/' ? 'text-white/60 hover:text-white' : 'text-black/60 hover:text-black')
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="flex items-center space-x-6 pl-4 border-l border-accent-orange/30">
                <Link 
                  to="/shorts" 
                  className={`text-[10px] font-bold uppercase tracking-[0.2em] transition-all duration-500 ${
                    location.pathname === '/shorts'
                      ? 'text-accent-orange'
                      : (scrolled || location.pathname !== '/' ? 'text-white/60 hover:text-white' : 'text-black/60 hover:text-black')
                  }`}
                >
                  Shorts
                </Link>
                <Link 
                  to="/print" 
                  className={`text-[10px] font-bold uppercase tracking-[0.2em] transition-all duration-500 ${
                    location.pathname === '/print'
                      ? 'text-accent-orange'
                      : (scrolled || location.pathname !== '/' ? 'text-white/60 hover:text-white' : 'text-black/60 hover:text-black')
                  }`}
                >
                  In Print
                </Link>
                <Link 
                  to="/contact" 
                  className="bg-accent-orange text-white px-6 py-2.5 rounded-full text-[10px] font-bold hover:bg-white hover:text-black transition-all duration-500 shadow-lg uppercase tracking-widest"
                >
                  Work With Us
                </Link>
              </div>
            </div>
          </nav>

          <div className="lg:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`p-2 transition-transform duration-500 hover:scale-110 ${
                scrolled || location.pathname !== '/' ? 'text-white' : 'text-black'
              }`}
            >
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className="lg:hidden mt-4"
          >
            <div className="flex flex-col space-y-4 py-8 bg-black rounded-2xl shadow-2xl px-8 border border-white/10">
              {[...filmLinks, { name: 'YouTube Shorts', path: '/shorts' }, { name: 'In Print', path: '/print' }, { name: 'The Team', path: '/team' }].map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`text-sm font-bold uppercase tracking-widest transition-colors duration-500 ${
                    location.pathname === item.path ? 'text-accent-orange' : 'text-white/70 hover:text-white'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link 
                to="/contact" 
                className="bg-accent-orange text-white px-6 py-4 rounded-xl text-center font-bold uppercase tracking-widest hover:bg-white hover:text-black transition-all duration-500"
              >
                Collaborate
              </Link>
            </div>
          </motion.div>
        )}
      </div>
    </motion.header>
  );
};

export default Header;